document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.open-support-chat');
  if (!trigger) return;

  e.preventDefault();
  e.stopPropagation();

  if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
    window.GorgiasChat.open();
  } else {
    console.warn('Gorgias chat not available yet.');
  }
});